import { render } from "./SpaModal.vue?vue&type=template&id=61e82528&scoped=true"
import script from "./SpaModal.vue?vue&type=script&lang=js"
export * from "./SpaModal.vue?vue&type=script&lang=js"

import "./SpaModal.vue?vue&type=style&index=0&id=61e82528&lang=css"
import "./SpaModal.vue?vue&type=style&index=1&id=61e82528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e82528"]])

export default __exports__